import { Controller } from "stimulus";

// 他のcontrollerから呼ばれることを想定ている
export default class ModalController extends Controller {
  open() {
    this.element.classList.remove("hidden");
  }

  close() {
    this.element.classList.add("hidden");
  }

  reload() {
    location.reload();
  }
}
